import React, {
  FC,
  ReactNode,
  createContext,
  useContext,
  useState,
  useLayoutEffect,
  SetStateAction,
  Dispatch,
} from 'react'
import { WithChildren } from '../../helpers'

const MetronicSplashScreenContext = createContext<Dispatch<SetStateAction<number>> | undefined>(
  undefined
)

type MetronicSplashScreenProviderProps = WithChildren & {
  /** Conteúdo da splash, exibido enquanto houver algum `<LayoutSplashScreen />` montado */
  splash: ReactNode
}

const MetronicSplashScreenProvider: FC<MetronicSplashScreenProviderProps> = ({
  children,
  splash,
}) => {
  const [count, setCount] = useState(0)
  const visible = count > 0

  return (
    <MetronicSplashScreenContext.Provider value={setCount}>
      {children}
      {visible && splash}
    </MetronicSplashScreenContext.Provider>
  )
}

const LayoutSplashScreen: FC<{ visible?: boolean }> = ({ visible = true }) => {
  // Everything are ready - remove splashscreen
  const setCount = useContext(MetronicSplashScreenContext)

  useLayoutEffect(() => {
    if (!visible) {
      return
    }

    if (setCount) {
      setCount((prev) => {
        return prev + 1
      })
    }

    return () => {
      if (setCount) {
        setCount((prev) => {
          return prev - 1
        })
      }
    }
  }, [setCount, visible])

  return null
}

export { MetronicSplashScreenProvider, LayoutSplashScreen }
